import {Observable, of as observableOf} from 'rxjs';
import {map, catchError, filter} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Store, select} from '@ngrx/store';

import {getAuthenticatedUser, State} from '@app/app.reducers';
import {User} from '../model/user';
import {AuthenticatedUserService} from '../service/authenticated-user.service';

@Injectable()
export class LandingGuard implements CanActivate {

    private authenticatedUser$: Observable<User>;

    constructor(private router: Router,
                private authenticatedUserService: AuthenticatedUserService,
                private store: Store<State>
    ) {
        this.authenticatedUser$ = this.store.pipe(select(getAuthenticatedUser));
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authenticatedUser$
            .pipe(
                filter(user => !!user),
                map(user => {
                    if (this.authenticatedUserService.isProvider(user)) {
                        this.router.navigate(['/admin/applications']);
                    } else if (this.authenticatedUserService.isVendor(user)) {
                        this.router.navigate(['/admin/institutions']);
                        // } else if (this.authenticatedUserService.isSysAdmin(user) || this.authenticatedUserService.isServiceOperator(user)) {
                        //     this.router.navigate(['/administrations']);
                        // } else {
                        return true;
                    }
                }),
                catchError((err) => {
                    console.log(err);
                    return observableOf(false);
                })
            );
    }
}
